<template>
  <el-row class="pond-charts">
    <el-row :gutter="10">
      <el-col class="chart pg-charts__data-do-ph" :span="12">
        <pg-status-graph></pg-status-graph>
      </el-col>
      <el-col class="chart pond-charts__feed-cumulative" :span="12">
        <pond-schedule-graph></pond-schedule-graph>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col class="chart pond-charts__growth-vs-biomass" :span="12">
        <pond-awg-biomass-graph></pond-awg-biomass-graph>
      </el-col>
      <el-col class="chart pond-charts__feed-hourly" :span="12">
        <pond-hourly-graph></pond-hourly-graph>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col class="chart pond-charts__manual-feed" :span="12">
        <manual-feed-graph></manual-feed-graph>
      </el-col>
      <el-col class="chart pm-charts__feed-cumulative" :span="12">
        <pm-schedule-graph></pm-schedule-graph>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="chart">
        <st-status-graph></st-status-graph>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="chart">
        <st-ocf-and-fg-graph></st-ocf-and-fg-graph>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import pondHourlyGraph from "@/components/graphs/pondHourlyGraph";
import pondScheduleGraph from "@/components/graphs/pondScheduleGraph";
import pmScheduleGraph from "@/components/graphs/pmScheduleGraph";
import pgStatusGraph from "@/components/graphs/pgStatusGraph";
import stStatusGraph from "@/components/graphs/stStatusGraph";
import stOcfAndFgGraph from "@/components/graphs/stOcfAndFgGraph";
import manualFeedGraph from "@/components/graphs/manualFeedGraph";
import pondAwgBiomassGraph from "@/components/graphs/pondAwgBiomassGraph";

import { mapGetters } from "vuex";
export default {
  components: {
    pondHourlyGraph,
    pondScheduleGraph,
    pmScheduleGraph,
    pgStatusGraph,
    stStatusGraph,
    pondAwgBiomassGraph,
    manualFeedGraph,
    stOcfAndFgGraph
  },
  data: function() {
    return {
      // pondId: "",
      pondDetails: null
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      pondId: "getSelectedPondId"
    })
  },
  methods: {}
};
</script>

<style lang="scss">
.pond-charts {
  .card-title {
    line-height: 2;
  }
  & > .el-row {
    display: flex;
    flex-direction: row;
    .er-card {
      height: 100%;
      // padding: 10px;
      .el-card__header {
        padding: 5px 10px;
      }
    }
    margin-bottom: 10px;
  }
  .chart {
    // border: 1px solid blue;
    b {
      font-weight: 500;
    }
  }
  .el-input__inner {
    @include small-text;
  }
  .el-input__icon.el-range__close-icon {
    display: none;
  }
}
</style>
